// @flow
import React from "react";
import type { GazelleData, GazelleObject } from "../../types/gazelle.js";
import { findRef } from "../../utils/gazelle.js";
import HtmlText from "./HtmlText.js";
import InlineImage from "./InlineImage.js";
import PlayerPlaceholder from "./PlayerPlaceholder.js";

const HTML_TEXT = "html-text";
const INLINE_IMAGE = "inline-image";
const AUDIO_PLAYER = "audio-player";
const VIDEO_PLAYER = "video-player";

export default function VerticalStackElement(props: {
  gazelleData: GazelleData,
  verticalStackElementData: GazelleObject
}) {
  const { gazelleData, verticalStackElementData } = props;
  const attributes = verticalStackElementData.get("attributes");
  const contentData = findRef(gazelleData, attributes.get("content"));

  if (contentData == null) {
    return null;
  }

  var children = null;
  switch (contentData.get("type")) {
    case HTML_TEXT:
      children = (
        <HtmlText gazelleData={gazelleData} htmlTextData={contentData} />
      );
      break;
    case INLINE_IMAGE:
      children = (
        <InlineImage gazelleData={gazelleData} inlineImageData={contentData} />
      );
      break;
    case AUDIO_PLAYER:
      children = <PlayerPlaceholder label="Audio" />;
      break;
    case VIDEO_PLAYER:
      children = <PlayerPlaceholder label="Video" />;
      break;
  }

  return (
    <div
      style={{
        paddingTop: attributes.get("top-padding"),
        paddingBottom: attributes.get("bottom-padding")
      }}
    >
      {children}
    </div>
  );
}



// WEBPACK FOOTER //
// ./enso_cms/static/enso-cms/js/components/gazelle/VerticalStackElement.js